import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { usePredictedSubscription } from 'reactApp/hooks/usePersonalizationPromoInformation';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import {
    openPersonalizationModal,
    usePersonalizationSidebarImg,
} from 'reactApp/ui/PersonalizationUpsaleBanner/PersonalizationUpsaleBanner.helpers';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './PersonalizationUpsaleBanner.css';

export const PersonalizationUpsaleBanner: React.FC = () => {
    const isDarkTheme = useSelector(isCurrentDarkTheme);
    const { space: promoSpace } = usePredictedSubscription();
    const image = usePersonalizationSidebarImg(promoSpace?.space);

    useEffect(() => {
        sendDwh({
            eventCategory: 'personalization-upsale-banner',
            action: 'show',
        });
    }, []);

    const handleClick = useCallback(() => {
        sendDwh({
            eventCategory: 'personalization-upsale-banner',
            action: 'click',
        });
        openPersonalizationModal();
    }, []);

    return (
        <div className={classNames(styles.root, { [styles.darkRoot]: isDarkTheme })} onClick={handleClick}>
            <div className={styles.image}>
                <img src={image} alt="Персонализация" />
            </div>
            <Text className={styles.text}>Добавить за 1 ₽</Text>
        </div>
    );
};
